import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import {
  SystemTrustedCertificateForm,
  mountForm,
  unmountForm,
  refetchTable,
  showToast,
} from '@kineticdata/react';
import { generateFormButtons, FormError } from '@kineticdata/ui';
import { Link } from 'react-router-dom';
import { regSaga, regRoute } from '../../store';
import { navigate } from '../../root';
import { tableKey } from './SystemSetupTrustedCertificates';

const formKey = 'system-setup-certs-new';

export const restartResourcesToastDefinition = {
  icon: 'info',
  title: 'Restart components',
  content: (
    <div>
      <div>One or more components requires a restart.</div>
      <div>
        <Link to="/system/components">Go to the System Components.</Link>
      </div>
    </div>
  ),
  autoHide: false,
};

regRoute('SYSTEM_CERTS_NEW_PAGE', '/system/setup/infra/certs/new');

regSaga(
  takeEvery('ENTER_SYSTEM_CERTS_NEW_PAGE', function*() {
    yield call(mountForm, formKey);
  }),
);
regSaga(
  takeEvery('LEAVE_SYSTEM_CERTS_NEW_PAGE', function*() {
    yield call(unmountForm, formKey);
  }),
);

const handleSave = () => () => {
  refetchTable(tableKey);
  navigate(`/system/setup/infra/certs`);
  showToast(restartResourcesToastDefinition);
};

export const SystemSetupTrustedCertificatesNew = () => {
  return (
    <>
      <div className="heading heading-sm">
        <h2 className="h3">Add Trusted Certificates</h2>
      </div>
      <div className="content-container">
        <SystemTrustedCertificateForm
          formKey={formKey}
          onSave={handleSave}
          components={{
            FormError,
            FormButtons: generateFormButtons({
              submitLabel: 'Add Trusted Certificates',
              cancelPath: '/system/setup/infra/certs',
            }),
          }}
        />
      </div>
    </>
  );
};
